import React from "react";
import Layout from "../components/layout";
import Welcome from "../components/about/welcome";
import Awards from "../components/about/awards";
import Testimonials from "../components/about/testimonials";
import Interests from "../components/about/interests";

const AboutPage = () => {
    return (
        <Layout title="About">
            <Welcome />
            <Testimonials />
            <Awards />
            <Interests />
        </Layout>
    );
};

export default AboutPage;
